const translation = {
  offRules: 'Official Rules',
  // Navigation pages
  play: 'PLAY',
  recent: 'RECENT',
  howToPlay: 'HOW TO PLAY',

  // Card
  signUp: 'SIGN UP TO PLAY',
  viewMy: 'VIEW MY CARD',
  view: 'VIEW CARD',
  registered: 'REGISTERED',
  entry: 'Entry',
  entries: 'Entries',
  contestClosed: 'BINGO CONTEST CLOSED',
  ifNecessary: 'IF NECESSARY',

  //Signup modal
  reg: 'You are registered to play Olybet Bingo',
  rel: 'Your Bingo Card will be revealed in:',
  come: 'Come back to see your card when the event begins',
  priz: 'Prizing',
  regen: 'Bingo card auto-scores during game',
  //Wait modal
  hangTight: 'HANG TIGHT!',
  cardToBeGenerated: 'Waiting for BINGO CARD TO BE GENERATED.',
  mayTakeUpFewMinutes: 'THIS CAN TAKE UP TO A FEW MINUTES',

  // How to play page
  vert: 'VERTICAL',
  horiz: 'HORIZONTAL',
  diag: 'DIAGONAL',
  fullCard: 'FULL CARD',
  earnEntriesIntoDraw:
    'EARN PRIZES FOR GETTING A FULL ROW, DIAGONAL OR FULL CARD. YOUR CELLS WILL SCORE IF THE EVENT IN THE CELL BECOMES TRUE.',
  autoScoresDuringGame: 'BINGO CARD AUTO-SCORES DURING GAME',
  clickForMoreInfo: 'For more information, click here for',
  SOG: 'SOG – Shot on Goal (any shot scored as a shot on goal. Does not include blocked shots or shots that hit the post)',
  PPG: 'PPG – Power Play Goal (a goal scored by a team playing with a man advantage. For example, a team that is playing at a man advantage of 5v4, 5v3, or 4v3)',
  SHG: 'SHG – Short-Handed Goal (a goal scored by a team with a player currently serving a penalty)',
  PIM: 'PIM – Penalties in Minutes',
  FOPercent: 'FO% - Face-off Percentage',
  PTS: 'PTS – Points (either a goal or an assist)',
  entryPerRow: 'ENTRY PER ROW',
  totalEntries: 'TOTAL ENTRIES',
  perRow: 'PER ROW',

  //Home page
  bingoMayTakeUp:
    'Bingo cards may take up to 30 minutes post game to score all events',
  welcomeTo: 'Welcome to BingOly!',
  reviewInRecent: 'Review your past cards in the recent tab',
  thanksForPlaying: '',
  agreeToRules: 'By signing up you acknowledge and agree to the',

  //Recent page
  noRecentContests: 'No recent contests',
  //Game field page
  gamePrizeText:
    'Win a €100 Freebet if you score all of your cells or a €5 Freebet if you manage to get at least one row or a diagonal. Prizes will be distributed in working hours.',
  cardUpdateAfterPeriod: 'Card will update every 30 minutes',
  anyLine: 'ANY LINE',
  vertLines: 'VERT LINES',
  line: 'LINE',
  horzLines: 'HORZ LINES',

  //Onboarding page
  letsGetStarted: 'Let’s Get Started',
  makeSureToEnterSelections:
    'Make sure to enter your selections each day to compete for daily prizes. Remember to enter your selection for the tie breaker question before submitting your pick. You can edit your picks up until the start of the live game. Earn points for each correct prediction made.',
  playWithFriends:
    'Play with Friends. Who’s got game? Challenge your friends to play in a private league. Go to the leaderboard section, hit the Create button to start, and share the PIN code with your friends to join.',
  scoring: 'Scoring',
  challengeFriends: 'Challenge Friends',
  skip: 'skip',
  next: 'next',

  logout: 'Log out',
  returnToGamezone: 'Return to GameZone',
  rules: 'RULES',
  back: 'Back',

  bingo: 'BingOly',
  gamezone: 'Gamezone',
  justAFewMinutes: 'Just a few minutes, please refresh the page',
  fourCorners: 'FOUR CORNERS',
  rulesNotFound: 'Rules not found',
  offWebsiteText:
    'OFFICIAL WEBSITE OF THE EVENT WILL BE CONSIDERED AS PRIMARY SOURCE OF RESULTS. IF NOT AVAILABLE OTHER REPUTABLE SOURCES OR LIVE FOOTAGE WILL BE USED.',

  backToOlybet: 'Späť na OlyBet',
  confirmNewPassword: 'Confirm New Password',
  confirmNewPasswordIsRequired: 'Confirm New Password is a required field',
  confirmPassword: 'Potvrďte heslo',
  confirmPasswordIsRequired: 'Confirm Password is a required field',
  country: 'Krajina bydliska',
  countryIsRequired: 'Country is a required field',
  didNotMeanToUnsubscribe: 'Nechcel si sa odhlásiť',
  email: 'E-mail',
  emailAddressAlreadyInUse: 'Email address already in use',
  emailIsRequired: 'Email is a required field',
  emailOrUsername: 'E-mail alebo používateľské meno',
  emailOrUsernameIsRequired: 'Email or username is a required field',
  enterYourDetails: 'Zadajte svoje údaje nižšie',
  enterYourEmail: 'Zadajte svoj e-mail na obnovenie hesla',
  errorDuringLogin: 'Error during login',
  errorDuringRegistration: 'Error during registration',
  errorDuringSubscribing: 'Error during subscribing',
  errorDuringUnsubscribing: 'Error during unsubscribing',
  errorUpdatingProfile: 'Error updating profile',
  firstName: 'Prvé meno',
  firstNameIsRequired: 'First Name is a required field',
  firstNameMusBeAtLeast: 'First Name must be at least 3 characters',
  firstNameMustNotExceed: 'First Name must not exceed 100 characters',
  forgotPassword: 'Forgot Password',
  getResetLink: 'Get reset link',
  goodbye: 'Dovidenia',
  inappropriateWordsNotAllowed:
    'Inappropriate words and phrases are not allowed',
  informationAndPromotionalAgreement:
    'Súhlasím so zasielaním informácií a marketingových ponúk od spoločnosti OlyBet na kontaktné údaje uvedené tu. Povolenia môžem kedykoľvek zmeniť kliknutím na odkaz v spodnej časti marketingovej komunikácie. Viac informácií o spracúvaní údajov nájdete v Oznámení o ochrane osobných údajov.',
  inOrderToPlayAndRedeemPrizes:
    'Aby ste mohli hrať a získať ceny, musia byť vaše údaje presné a overené. Niektoré ceny sa vyplácajú na účet OlyBet, na získanie týchto cien musíte mať účet OlyBet so zhodnými údajmi (meno a e-mail).',
  invalidCredentials: 'Invalid credentials',
  invalidEmailFormat: 'Invalid email format',
  itIsRequiredField: 'It is a required field',
  joinNow: 'Join Now',
  lastName: 'Priezvisko',
  laststNameIsRequired: 'Last Name is a required field',
  laststNameMusBeAtLeast: 'Last Name must be at least 3 characters',
  laststNameMustNotExceed: 'Last Name must not exceed 100 characters',
  login: 'Login',
  mustBeChecked: 'Must be checked',
  mustContainFrom8To20Characters: 'Must contain from 8 to 20 characters',
  mustContainOneLowercase: 'Must contain at least one lowercase',
  mustContainOneNumber: 'Must contain at least one number',
  mustContainOneUppercase: 'Must contain at least one uppercase',
  newPassword: 'New Password',
  newPasswordIsRequired: 'New Password is a required field',
  oops: 'Oops! Something went wrong...',
  over$PrizeValueWon: 'Over <1>$1,000,000</1> prize value won',
  password: 'Heslo',
  passwordDoNotMatch: 'Heslá sa nezhodujú',
  passwordIsRequired: 'Password is a required field',
  passwordNotMeetCriteria: 'Heslo nespĺňa kritériá',
  passwordSuccessfullyReset: 'Password successfully reset',
  pleaseCheckYourEmailInbox: 'Please check your email inbox',
  profile: 'Profil',
  resetLinkSent: 'Reset link sent',
  resetPassword: 'Obnoviť heslo',
  resubscribe: 'Opätovne sa prihláste na odber',
  saveChanges: 'Save changes',
  signIn: 'Prihlásiť sa',
  success: 'Úspešne!',
  successfullyLoggedIn: 'Successfully logged in',
  successfullySentResetLink: 'Successfully sent reset link to your email',
  successfullySignedUp: 'Úspešne!',
  successfullySubscribed: 'Successfully subscribed',
  successfullyUnsubscribed: 'Successfully unsubscribed',
  successfullyUpdatedProfile: 'Successfully updated profile',
  unsubscribe: 'Odhlásiť sa z odberu',
  username: 'Používateľské meno',
  usernameAlreadyInUse: 'Už máte konto?',
  usernameIsRequired: 'Username is a required field',
  veryStrongPassword: 'Very strong password',
  welcomeBack: 'Vitajte späť!',
  youHaveSuccesfullyUnsubscribed:
    'Úspešne ste sa odhlásili z odberu marketingových správ od OlyBet.',
  yourEmail: 'Your email',
  youWishToUnsubscribe:
    'Ak ste si istí, že si želáte zrušiť odber marketingových správ od OlyBet, kliknite prosím nižšie.',
  accountInfo: 'Account Information',
  availableGames: 'Available Games',
  contactNumber: 'Contact number',
  days: 'Days',
  gameDetails: 'Game details',
  legalConsent: 'Consent of legal docs',
  live: 'LIVE',
  liveGames: 'Live Games',
  marketingConsent: 'Consent to marketing',
  mobileNumber: 'Mobile number',
  mobileNumberIsRequired: 'Mobile number is a required field',
  mobileNumberMustBeAtLeast: 'Mobile number must be at least 6 characters',
  mobileNumberMustNotExceed: 'Mobile number must not exceed 15 characters',
  myContest: 'My Contests',
  myHistory: 'My History',
  nationality: 'Nationality',
  nickname: 'Nickname',
  nicknameAlredyInUse: 'Nickname already in use',
  nicknameIsRequired: 'Nickname is a required field',
  noHistoryYet: 'There is no history yet',
  noUpcomingContestsYet: 'There are no upcoming contests yet',
  personalDetails: 'Personal Details',
  playNow: 'Play now',
  preferences: 'Preferences',
  recentWinners: 'Recent Winners',
  region: 'Region',
  returnToLogin: 'Return to login',
  upload: 'Upload',
  win: 'win',
  winner: 'Winner',
  zipCode: 'Zip code',
  zipCodeIsRequired: 'ZIP code is a required field',
  zipCodeMustBeAtLeast: 'ZIP code must be at least 3 characters',
  zipCodeMustNotExceed: 'ZIP code must not exceed 10 characters',
};
export default translation;
